export function mapRasse(rasse: string): string {
  switch (rasse) {
    case 'H448':
      return 'H290';
    case 'H572':
      return 'H623';
    case 'H395':
      return 'H209';
    case 'H598':
      return 'H210';
    case 'H677':
      return 'H867';
    case 'H620':
      return 'H265';
  }
  return rasse;
}

export function mapRassen(rassen: string[]): string[] {
  if (rassen) {
    return rassen.map(rasse => mapRasse(rasse));
  }
  return [];
}

export function mapRasseTkv(rasse: string): string {
  switch (rasse) {
    case 'H346':
      return 'H345';
    case 'D225':
      return 'D224';
  }
  return rasse;
}

export function refreshBreedLabel<T extends { label: string }>(breed: T, freshLabel: string): T {
  if (!breed) {
    return breed;
  }
  return freshLabel ? { ...breed, label: freshLabel } : breed;
}
